import React, { createContext, useContext, useState } from "react";

const ChatModalContext = createContext();

export function useChatModal() {
  const context = useContext(ChatModalContext);
  if (!context) {
    // Return default values jika context tidak tersedia (untuk kompatibilitas)
    return {
      isOpen: false,
      openModal: () => {},
      closeModal: () => {},
      toggleModal: () => {},
    };
  }
  return context;
}

export function ChatModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <ChatModalContext.Provider
      value={{ isOpen, openModal, closeModal, toggleModal }}
    >
      {children}
    </ChatModalContext.Provider>
  );
}
